"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const math_1 = require("../utils/math");
function updateWorstScore(aggregatedStat, sessionEvent) {
    const { session } = sessionEvent;
    return (0, math_1.getMinimumValue)(aggregatedStat.worstScore, session.sessionScore);
}
exports.default = updateWorstScore;
